import {gsap} from "gsap";
import {PunkRocker} from "../../../PunkRocker";
import {TrainState} from "./TrainState";
import {LayoutDimData} from "../../../../core/utils/ResizeHelper";
import {PREngineManager} from "../../../punkEngine/PREngineManager";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SpinePlayer} from "../../../../core/displayobject/SpinePlayer";
import {PRGameMode} from "../../../server/PRGameMode";
import {GameData} from "../../../server/data/GameData";
import {SoundManager} from "../../../sound/SoundManager";
import {SoundConfig} from "../../../sound/SoundConfig";
import {GameConfig} from "../../../config/base/GameConfig";

export class NoServiceView extends PIXI.Container {
    private _noService: SpinePlayer;
    private _bottomTrainVisible: boolean = false;

    constructor() {
        super();
        this.name = "NoServiceView";

        this.init();
        this.onResize();
    }

    onResize() {
        this.position.set(360, 90);

        const scaledReelDim: LayoutDimData = this._bottomTrainVisible ? PREngineManager.dimScaled : PREngineManager.dim;

        if (NolimitApplication.isLandscape && this._bottomTrainVisible) {
            this.position.set(360, 85);
        } else {
            this.position.set(360, 90);
        }
        this.scale.set(scaledReelDim.scale.x, scaledReelDim.scale.y);
    }

    public onBottomTrainShow(flag: boolean, isRestore: boolean = false): void {
        this._bottomTrainVisible = flag;
        this.onResize();
    }

    public toggleServiceBoard(showBoard: boolean, fromFeature: string = ""): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        if (showBoard) {
            tl.add(this.fadeInBoard());
        } else {
            if (fromFeature) {
                if (fromFeature === PRGameMode.FREESPIN_LEVEL_TWO || fromFeature === PRGameMode.FREESPIN_LEVEL_THREE) {
                    tl.add(this.fadeInBoard());
                }
                tl.add([
                    this._noService.play({
                        animation: "trigger"
                    }),
                    // #392
                    () => {
                        SoundManager.playSoundEffect(SoundConfig.NOT_IN_SERVICE_EXPLODE);
                    }
                ]);
            } else {
                this._noService.visible = false;
            }
        }

        return tl;
    }

    public arriveBottomTrainOnly(fromFeature: string): void {
        if (!(PunkRocker.trainsManager.bottomTrain.isTrainVisible("bottomTrain"))) {
            const currGameData: GameData = PunkRocker.model.gameData,
                bottomTrainFeatures: string[] = currGameData.raw.bottomTrain,
                tl: gsap.core.Timeline = new gsap.core.Timeline();

            PunkRocker.trainsManager.bottomTrain.setTrainItems(bottomTrainFeatures);
            PunkRocker.trainsManager.bottomTrain.setTrainAlpha(true, 0.2);
            PunkRocker.trainsManager.bottomTrain.toggleDisplay(true);

            tl.add(() => {
                this.toggleServiceBoard(false, fromFeature);
            }, 0);
            tl.add(() => {
                PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_ENTER, true);
            }, 1);
            if (fromFeature === "UPGRADE" && currGameData.mode === PRGameMode.FREESPIN_LEVEL_ONE) {
                tl.add(() => {
                    PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_OPEN_ONLY, true);
                });
            } else {
                tl.add(() => {
                    if (GameConfig.TRAIN_PRESENTATION_SKIPPED) {
                        PunkRocker.trainsManager.bottomTrain.setTrainState(TrainState.TRAIN_OPEN_ONLY, true);
                    } else {
                        PunkRocker.trainsManager.bottomTrain.trainLoop(true);
                    }
                });
            }
        }
    }

    private fadeInBoard(): gsap.core.Timeline {
        const tl: gsap.core.Timeline = new gsap.core.Timeline();

        this.resetSpine();
        this._noService.visible = true;
        this._noService.alpha = 0;

        tl.to(this._noService, {
            duration: 0.5,
            delay: 0.167,
            alpha: 1
        });

        return tl;
    }

    private resetSpine(): void {
        this._noService.spine.state.clearTracks();
        this._noService.spine.skeleton.setToSetupPose();
        this._noService.spine.skeleton.setBonesToSetupPose();
        this._noService.spine.skeleton.setSlotsToSetupPose();
    }

    private init(): void {
        this._noService = this.addChild(new SpinePlayer("notInService"));
        this._noService.position.set(0, 599);
        this.addChild(this._noService);
    }
}